export default {
  title: 'Betalen met PayPal',
  error: 'De PayPal-betaling kon niet worden voltooid. Probeer het opnieuw.',
};
